__turbopack_context__.v({
  "aside": "qMzwiq_aside",
  "body": "qMzwiq_body",
  "eyebrow": "qMzwiq_eyebrow",
  "heading": "qMzwiq_heading",
  "lead": "qMzwiq_lead",
  "title": "qMzwiq_title",
});
